module.exports = __webpack_public_path__ + "media/images/pages/hazard/bg_area_02-45edffeb2f7d07528e0b58eac79958d9.png";